export const size = {
    HEADER: '56px'
}